// Language configuration in your Prismic repository: Settings / Translations & locals
export const defaultLanguage = 'en-us'
export const langs = ['en-us', 'sv-se', 'en-se', 'no-no', 'en-no']
